import { Provider } from '@vgtv/api-client';

function getHomepageSlug(provider: Provider): string {
  return provider === Provider.VGTV ? 'hjem' : 'hem';
}

export { getHomepageSlug };
